// The Sero size finder: recommends a size from height/weight or body measurements,
// using the size chart from Theme settings, limited to the sizes this product has.
(() => {
  const MEASURES = [
    { key: 'bust', label: 'Στήθος' },
    { key: 'waist', label: 'Μέση' },
    { key: 'hip', label: 'Περιφέρεια' },
  ];

  // Chart lines look like "S | 80-86 | 60-66 | 86-92" (size | bust | waist | hips, in cm).
  const parseChart = (text) =>
    String(text || '')
      .split(/\n|<br\s*\/?>|<\/p>/i)
      .map((line) => line.replace(/<[^>]+>/g, '').trim())
      .filter(Boolean)
      .map((line) => line.split('|').map((part) => part.trim()))
      .filter((parts) => parts.length >= 4)
      .map(([size, ...ranges]) => {
        const row = { size };
        MEASURES.forEach(({ key }, index) => {
          const [lo, hi] = String(ranges[index] || '').split(/[-–]/).map((n) => parseFloat(n));
          if (!Number.isNaN(lo)) row[key] = { lo, hi: Number.isNaN(hi) ? lo : hi };
        });
        return row;
      });

  const norm = (size) => String(size).toUpperCase().replace(/\s+/g, '');

  // Match the product's sizes to chart rows; "XL-2XL" covers both rows.
  const rowsForProduct = (chart, sizes) =>
    sizes
      .map((size) => {
        const parts = norm(size).split('-');
        const matches = parts.map((part) => chart.find((row) => norm(row.size) === part)).filter(Boolean);
        if (!matches.length || matches.length !== parts.length) return null;
        const merged = { size };
        MEASURES.forEach(({ key }) => {
          const ranges = matches.map((row) => row[key]).filter(Boolean);
          if (ranges.length) merged[key] = { lo: Math.min(...ranges.map((r) => r.lo)), hi: Math.max(...ranges.map((r) => r.hi)) };
        });
        return merged;
      })
      .filter(Boolean);

  // Rough body measurements from height and weight (approximation, shown as such).
  const estimate = (height, weight) => {
    const bmi = weight / Math.pow(height / 100, 2);
    return {
      bust: 88 + 1.9 * (bmi - 22) + 0.2 * (height - 165),
      waist: 70 + 2.1 * (bmi - 22) + 0.2 * (height - 165),
      hip: 96 + 1.8 * (bmi - 22) + 0.3 * (height - 165),
    };
  };

  const recommend = (rows, values, fit) => {
    const keys = MEASURES.map((m) => m.key).filter((key) => values[key] != null && rows.some((row) => row[key]));
    if (!keys.length) return null;
    const last = rows.length - 1;
    let index = 0;
    let tooBig = false;
    keys.forEach((key) => {
      let i = rows.findIndex((row) => row[key] && values[key] <= row[key].hi);
      if (i === -1) {
        i = last;
        tooBig = true;
      }
      index = Math.max(index, i);
    });
    let between = false;
    if (fit === 'slim' && index > 0 && keys.every((key) => !rows[index - 1][key] || values[key] <= rows[index - 1][key].hi + 2)) {
      index -= 1;
      between = true;
    }
    if (fit === 'loose' && index < last && keys.some((key) => rows[index][key] && values[key] >= rows[index][key].hi - 2)) {
      index += 1;
      between = true;
    }
    const row = rows[index];
    const chips = keys.map((key) => {
      const range = row[key];
      const label = MEASURES.find((m) => m.key === key).label;
      if (!range) return null;
      if (values[key] > range.hi) return { label, verdict: 'Πιο στενό', tone: 'tight' };
      if (values[key] < range.lo - 3) return { label, verdict: 'Πιο άνετο', tone: 'loose' };
      return { label, verdict: 'Καλή εφαρμογή', tone: 'good' };
    }).filter(Boolean);
    return { size: row.size, tooBig, between, chips };
  };

  const init = (modal) => {
    if (modal.dataset.ready) return;
    modal.dataset.ready = 'true';
    const chart = parseChart(JSON.parse(modal.querySelector('[data-sf-chart]').textContent || '""'));
    const rows = rowsForProduct(chart, (modal.dataset.sizes || '').split('|').filter(Boolean));
    modal.sizeFinderUsable = rows.length >= 2;
    if (!modal.sizeFinderUsable) return;

    let mode = 'quick';
    let fit = 'regular';
    const $ = (selector) => modal.querySelector(selector);
    const $$ = (selector) => [...modal.querySelectorAll(selector)];
    const input = (key) => $(`[data-sf-input="${key}"]`);

    // Size chart table, only with this product's sizes. A tap on a row picks that size.
    const shown = MEASURES.filter(({ key }) => rows.some((row) => row[key]));
    $('[data-sf-table]').innerHTML =
      `<thead><tr><th>Μέγεθος</th>${shown.map((m) => `<th>${m.label}<small>cm</small></th>`).join('')}</tr></thead>` +
      `<tbody>${rows
        .map(
          (row) =>
            `<tr data-sf-row="${row.size}" tabindex="0"><th><span class="size-finder__size-badge">${row.size}</span></th>${shown
              .map(({ key }) => `<td>${row[key] ? `${row[key].lo}–${row[key].hi}` : '–'}</td>`)
              .join('')}</tr>`
        )
        .join('')}</tbody>`;

    // Pick a size in the product form and close the window.
    const chooseSize = (size) => {
      const info = document.querySelector('product-info') || document;
      const radio = [...info.querySelectorAll('variant-selects input[type="radio"]')].find((r) => r.value === size);
      if (radio) radio.click();
      modal.hide();
    };

    // Mark the recommended row and the size already picked on the page.
    const markRows = (recommended) => {
      const info = document.querySelector('product-info') || document;
      const checked = [...info.querySelectorAll('variant-selects input[type="radio"]:checked')].map((r) => r.value);
      $$('[data-sf-row]').forEach((tr) => {
        tr.classList.toggle('is-recommended', tr.dataset.sfRow === recommended);
        tr.classList.toggle('is-current', checked.includes(tr.dataset.sfRow));
      });
    };

    const update = () => {
      $$('[data-sf-input]').forEach((el) => {
        const out = $(`[data-sf-out="${el.dataset.sfInput}"]`);
        if (out) out.textContent = el.value;
        el.style.setProperty('--fill', `${((el.value - el.min) / (el.max - el.min)) * 100}%`);
      });
      const values =
        mode === 'quick'
          ? estimate(Number(input('height').value), Number(input('weight').value))
          : { bust: Number(input('bust').value), waist: Number(input('waist').value), hip: Number(input('hip').value) };
      const result = recommend(rows, values, fit);
      const select = $('[data-sf-select]');
      if (!result) return;
      $('[data-sf-size]').textContent = result.size;
      $('[data-sf-note]').textContent = result.tooBig
        ? 'Οι μετρήσεις σου είναι πάνω από τα μεγέθη αυτού του προϊόντος. Δες και τα σχέδια από τη συλλογή «Καμπύλες χωρίς όρια».'
        : result.between
          ? fit === 'slim'
            ? 'Είσαι ανάμεσα σε δύο μεγέθη: για πιο εφαρμοστό, το μικρότερο.'
            : 'Είσαι ανάμεσα σε δύο μεγέθη: για πιο άνετο, το μεγαλύτερο.'
          : mode === 'quick'
            ? 'Εκτίμηση με βάση ύψος και βάρος.'
            : 'Με βάση τις μετρήσεις σου.';
      $('[data-sf-chips]').innerHTML = modal.dataset.showFit !== 'true' ? '' : result.chips
        .map((chip) => `<span class="size-finder__chip size-finder__chip--${chip.tone}">${chip.label}: ${chip.verdict}</span>`)
        .join('');
      $('[data-sf-disclaimer]').hidden = mode !== 'quick';
      select.disabled = false;
      select.dataset.size = result.size;
      select.textContent = `Επίλεξε το ${result.size}`;
      markRows(result.size);
    };

    $$('[data-sf-tab]').forEach((tab) =>
      tab.addEventListener('click', () => {
        $$('[data-sf-tab]').forEach((t) => t.classList.toggle('is-active', t === tab));
        $$('[data-sf-panel]').forEach((panel) => (panel.hidden = panel.dataset.sfPanel !== tab.dataset.sfTab));
        if (tab.dataset.sfTab === 'chart') markRows($('[data-sf-select]').dataset.size);
      })
    );
    $$('[data-sf-mode]').forEach((button) =>
      button.addEventListener('click', () => {
        mode = button.dataset.sfMode;
        $$('[data-sf-mode]').forEach((b) => b.classList.toggle('is-active', b === button));
        $$('[data-sf-fields]').forEach((fields) => (fields.hidden = fields.dataset.sfFields !== mode));
        update();
      })
    );
    $$('[data-sf-fit]').forEach((button) =>
      button.addEventListener('click', () => {
        fit = button.dataset.sfFit;
        $$('[data-sf-fit]').forEach((b) => b.classList.toggle('is-active', b === button));
        update();
      })
    );
    $$('[data-sf-input]').forEach((el) => el.addEventListener('input', update));

    $('[data-sf-select]').addEventListener('click', (event) => chooseSize(event.currentTarget.dataset.size));
    $$('[data-sf-row]').forEach((tr) => {
      tr.addEventListener('click', () => chooseSize(tr.dataset.sfRow));
      tr.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseSize(tr.dataset.sfRow);
        }
      });
    });

    update();
  };

  // Keep the page behind still while the window is open (iOS ignores overflow: hidden on body).
  const lockWhileOpen = (modal) => {
    let scrollY = 0;
    new MutationObserver(() => {
      const open = modal.hasAttribute('open');
      if (open && !document.body.dataset.sizeFinderLock) {
        scrollY = window.scrollY;
        document.body.dataset.sizeFinderLock = 'true';
        Object.assign(document.body.style, { position: 'fixed', top: `-${scrollY}px`, left: '0', right: '0', width: '100%' });
      } else if (!open && document.body.dataset.sizeFinderLock) {
        delete document.body.dataset.sizeFinderLock;
        Object.assign(document.body.style, { position: '', top: '', left: '', right: '', width: '' });
        window.scrollTo(0, scrollY);
      }
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  };

  const connect = () => {
    document.querySelectorAll("modal-dialog[data-size-finder]").forEach((modal) => {
      // The product column has a transform (reveal animation), which traps fixed elements;
      // living under <body> keeps the window centred on the screen.
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
      init(modal);
      lockWhileOpen(modal);
      if (!modal.sizeFinderUsable) return;
      document.querySelectorAll('[data-size-guide]').forEach((link) => {
        link.hidden = false;
        link.dataset.finderTarget = modal.id;
        link.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            modal.show(link);
          },
          true
        );
      });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect);
  } else {
    connect();
  }
})();
